import {combineReducers} from 'redux';
import * as a from './actionTypes'

const authSessionDefault = { authenticatedUser: {}, isAuthenticated: false, authenticatedApp: '', isLauncherAuth: false };
function authSession(state = authSessionDefault, action) {
  switch (action.type) {
    case a.AUTH_SESSION:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

const eulaStateDefault = { eulaDoc: {}, popupEula: {} };
function eulaState(state = eulaStateDefault, action) {
  switch (action.type) {
    case a.EULA_STATE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

const tfaStateDefault = { required: false, useOverride: '', isWebAuthnRegistered: '', isTfaDeviceRegistered: '', prompt: '', webAuthnRequest: '' };
function tfaState(state = tfaStateDefault, action) {
  switch (action.type) {
    case a.TFA_STATE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

const authModeStateDefault = { requiresPasswordLessOtp: false, requiresPassword: false };
function authModeState(state = authModeStateDefault, action) {
  switch (action.type) {
    case a.AUTH_MODE_STATE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

function MAX_SESSIONS_EXCEED(state = {}, action) {
  switch (action.type) {
    case a.MAX_SESSIONS_EXCEED:
      return action.data;
    default:
      return state;
  }
}

const globalIdTransitionDefault = { errTransition: false, errNoGlobal: false, errAttemptsExceeded: false, token: '', remainingAttempts: '', email: '' };
function globalIdTransition(state = globalIdTransitionDefault, action) {
  switch (action.type) {
    case a.GLOBAL_ID_TRANSITION:
      return { ...state, ...action.data };
    default:
      return state;
  }
}


function authenticatedUserName(state = '', action){
	  switch (action.type) {
	    case a.AUTHENTICATED_USER:
	      return action.data;
	    default:
	      return state;
	  }
}

function errorMessage(state = '', action){
  switch (action.type) {
    case a.ERR_MSG:
      return action.data;
    default:
      return state;
  }
}

function contactVerified(state = false, action) {
  switch (action.type) {
    case 'USER_CONTACT_VERIFIED':
      return action.data;
    default:
      return state;
  }
}


const referenceDataDefault = { countries: [], countryByCode: {} };
function referenceData(state = referenceDataDefault, action) {
  switch (action.type) {
    case a.REFERENCE_DATA:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

function userProfile(state = {}, action){
  switch (action.type) {
    case a.USER_PROFILE:
      return action.data;
    default:
      return state;
  }
}

const userDashboardConfigDefault = { appConfigs: [], pageConfig: {}, favoriteApps: [], dashboardConfig: [] };
function userDashboardConfig(state = userDashboardConfigDefault, action) {
  switch (action.type) {
    case a.USER_DASHBOARD_CONFIG:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

function ssoEnvironment(state = {}, action){
  switch (action.type) {
    case a.SSO_ENV:
      return action.data;
    default:
      return state;
  }
}

const connectionTestDefault = { settings: {}, results: {}, iconResults: {} };
function connectionTestState(state = connectionTestDefault, action) {
  switch (action.type) {
    case a.CONNECTION_TEST_STATE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}


function isPasswordExpired(state = false, action){
  switch (action.type) {
    case a.PASSWORD_EXPIRED:
      return action.data;
    default:
      return state;
  }
}

function SAVED_AUTH_PARAM(state = {}, action) {
  switch (action.type) {
    case a.SAVED_AUTH_PARAM:
      return action.data;
    default:
      return state;
  }
}

function webauthnDetails(state = {}, action) {
  switch (action.type) {
    case a.WEBAUTHN_DETAILS:
      return action.data;
    default:
      return state;
  }
}

function authenticationParameters(state = {}, action) {
  switch (action.type) {
    case a.AUTHENTICATION_PARAMETERS:
      return action.data;
    default:
      return state;
  }
}

function sessionExpired(state = false, action) {
  switch (action.type) {
    case a.SESSION_EXPIRED_DIALOG:
      return action.data;
    default:
      return state;
  }
}


export default combineReducers(
    {
      globalIdTransition,
      tfaState,
      authModeState,
      eulaState,
      connectionTestState,
      authSession,
      authenticatedUserName,
      userProfile,
      userDashboardConfig,
      ssoEnvironment,
      errorMessage,
      contactVerified,
      referenceData,
      isPasswordExpired,
      SAVED_AUTH_PARAM,
      MAX_SESSIONS_EXCEED,
      webauthnDetails,
      authenticationParameters,
      sessionExpired
    }
)
